<template>
    <div>
        <template v-if="Array.isArray(displayToasts)" v-for="toast in displayToasts">
            <Component :is="toast" :data="toastData[toast]" @dismiss-toast="dismissToast"></Component>
        </template>
    </div>
</template>

<script>
import ResultRemoveBackground from './ResultRemoveBackground.vue';
import { eventBus } from '../../../../../lib/event-bus/event-bus';
import { TOAST_HIDE, TOAST_APPEND, TOAST_SHOW, TOASTS } from './toast-consts';
import ResultPDFAConversion from './ResultPDFAConversion.vue';
import ResultPDFAValidation from './ResultPDFAValidation.vue';
import ResultOCRHint from './ResultOCRHint.vue';
import ResultResizeImage from './ResultResizeImage.vue';

const toastComponents = {
    [TOASTS.TOAST_RESULT_REMOVE_BACKGROUND]: ResultRemoveBackground,
    [TOASTS.TOAST_RESULT_PDFA_CONVERSION]: ResultPDFAConversion,
    [TOASTS.TOAST_RESULT_PDFA_VALIDATION]: ResultPDFAValidation,
    [TOASTS.TOAST_RESULT_OCR_HINT]: ResultOCRHint,
    [TOASTS.TOAST_RESULT_RESIZE_IMAGE]: ResultResizeImage
};

export default {
    name: 'ResultInlineToasts',
    components: toastComponents,
    created() {
        eventBus.listen(TOAST_APPEND, (toast) => {
            this.addToast(toast.name, toast.data);
        });

        eventBus.listen(TOAST_SHOW, (toast) => {
            if (this.displayToasts.includes(toast.name)) {
                // toast already exists, ignore
                return;
            }

            this.addToast(toast.name, toast.data);
        });

        eventBus.listen(TOAST_HIDE, (toast) => {
            this.dismissToast(toast);
        });
    },
    methods: {
        addToast(toastName, toastData) {
            if (!Object.keys(toastComponents).includes(toastName)) {
                // toast not found, ignore
                return;
            }

            if (toastData) {
                this.$set(this.toastData, toastName, toastData);
            }

            this.displayToasts.push(toastName);
        },
        dismissToast(toastName) {
            const toastIndex = this.displayToasts.indexOf(toastName);

            if (toastIndex === -1) {
                // toast not found, ignore
                return;
            }

            this.displayToasts.splice(toastIndex, 1);

            if (this.toastData[toastName]) {
                this.$delete(this.toastData, toastName);
            }
        },
    },
    data() {
        return {
            displayToasts: [],
            toastData: {},
        };
    },
};
</script>
